import React, { ChangeEvent, FC, useCallback, useMemo, useRef } from 'react';

import { InputSize } from './types';

import { useTranslation } from 'app/lang';
import { isCorrectNumber, secureAmountValue } from 'app/lib/form';
import { formatMoney } from 'app/lib/formatters';

import { Input, InputProps } from './index';

// ---

export { InputSize };

// ---

type Event = ChangeEvent<HTMLInputElement>;
export type OnChangeHandler = (value: string, event?: Event) => void;

export type AmountInputProps = Omit<InputProps, 'onChange'> & {
  onChange?: OnChangeHandler;
  decimals?: number;
  customInput?: typeof Input;
};

// type Position = { start: number; end: number; };

// TODO: https://jira.tennisi.it/browse/BOOK-3024
const AmountInput: FC<AmountInputProps> = ({
  value,
  decimals,
  onChange,
  customInput: InputComponent = Input,
  ...props
}) => {
  const { lang } = useTranslation();

  const inputElement = useRef<HTMLInputElement>(null);
  // const [position, setPosition] = useState<Position | null>(null);

  const onChangeHandler = useCallback((event: Event) => {
    if (!onChange) {
      return;
    }

    // const { selectionStart, selectionEnd } = event.target;
    const value = secureAmountValue(event.target.value, decimals);
    if (!isCorrectNumber(value, { decimals })) {
      return;
    }

    // if (selectionStart !== null && selectionEnd !== null) {
    //   setPosition({ start: selectionStart, end: selectionEnd });
    // }

    onChange(value, event);
  }, [onChange, decimals]);

  //  useEffect(() => {
  //    if (inputElement.current && position !== null) {
  //      inputElement.current.setSelectionRange(position.start, position.end + 1);
  //    }
  //  }, [value]);

  const formatted = useMemo(() => (
    value ? formatMoney(value, lang, false, decimals) : ''
  ), [value, lang]);

  return (
    <InputComponent {...props}
                    ref={inputElement}
                    value={formatted}
                    onChange={onChangeHandler} />
  );
};

export default AmountInput;
